import axios from '@/plugins/axios'
import { format } from 'date-fns'

import Transform, { jsonParse } from '../../../../../global/utils/transform.class'
import { queryString } from 'common/utils/functions'

import { TEMPLATE } from '@/config'

const fetchInitData = async ({ productId }) => {
  const queryParamsObject = {}
  if (productId) queryParamsObject.product_id = productId

  const queryParamsString = queryString.stringify(queryParamsObject)
  const url = `${TEMPLATE}/data?${queryParamsString}`
  const { data } = await axios.get(url)

  const transformProduct = new Transform(data.product)
  const product = transformProduct.transform({ duration: [Number], capacity_max: [Number] }).get()

  return { ...data, product }
}

const checkAvailability = async ({ productId, date, amountPeople }) => {
  const queryParamsObject = {}
  if (productId) queryParamsObject.product_id = productId
  if (date) queryParamsObject.date = format(date, 'yyyy-MM-dd')
  if (amountPeople) queryParamsObject.amount_people = amountPeople

  const queryParamsString = queryString.stringify(queryParamsObject)
  const url = `${TEMPLATE}/check-availability?${queryParamsString}`
  const { data } = await axios.get(url)

  const transformOptions = new Transform(data.options)
  const options = transformOptions.transform({ guide_languages: [jsonParse] }).get()

  return { options }
}

const sendOrder = async ({ customer, order }) => {
  const customerData = {
    first_name: customer.firstName.trim(),
    last_name: customer.lastName.trim(),
    email: customer.email.trim().toLowerCase(),
    phone: customer.phone.trim(),
    country_code: customer.countryCode.trim().toUpperCase(),
    country_calling_code: customer.countryCallingCode.trim()
  }

  const bookingData = {
    product_id: order.productId,
    option_id: order.optionId,
    reference: 'pst',
    num_of_people: order.amountPeople,
    service_price_currency: order.service_price_currency,

    guide_languages: order.language,
    comment_by_customer: customer.message.trim()
  }

  const otherData = {
    schedule_id: order.scheduleId,
    price_id: order.priceId,
    price_slot_id: order.price.id,

    date: format(order.date, 'yyyy-MM-dd'),
    start_time_id: order.startTime.id
  }

  const { data } = await axios.post('bookings', {
    customerData,
    bookingData,
    otherData
  })

  return data
}

export default { fetchInitData, checkAvailability, sendOrder }
